<template>
    <v-container fluid>
    <v-row dense>
      <v-col cols="12">
        <DataTableMainServer
          :datatable="table"
          :on-success="SuccessTableAction"
          :itemsAction="SuccessTableAction"
          :Updatepagination="params"
          :on-pagination="pagePagination"
          :on-search="getSearchPagePagination"
        />
        <ViewDetails :object="object" type="JornadasDetails" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { Permission } from '@/mixins/permissionMain'
import { UserSession } from '@/store/modules/config'
import DataTableMainServer from '@/components/tables/DataTableMainServer'
import ViewDetails from '@/components/ViewDetails'

export default {
  mixins: [Permission],
  props: {
    deporte: {
      type: Object,
      required: true
    },
    ligas: {
      type: Array,
      default: () => []
    }
  },
  data: () => ({
    openDialog: false,
    table: {
      modelMain: [],
      showSelect: true,
      singleSelect: true,
      header: {
        options: [
          { title: 'Refrescar', icon: 'mdi-cached', color: 'primary', action: 'refreshData', code: 'libre', hidden: '' },
          { title: 'Nuevo', icon: 'mdi-plus', color: 'success', action: 'newData', code: 'liga.entry' }
        ],
        titles: [
          { text: 'Nombre De La Liga', value: 'nombre', class: 'black--text' },
          { text: 'Liga', value: 'descripcion.liga.categoria', class: 'black--text' },
          { text: 'Responsable', value: 'descripcion.responsable.NombreCompleto', class: 'black--text' },
          { text: 'Telefono', value: 'descripcion.responsable.caracteristicas.telefono', class: 'black--text' },
          { text: 'Max. de Equipos', value: 'descripcion.maxteam', class: 'black--text' },
          { text: 'Max. de Jugadores', value: 'descripcion.maxplayer', class: 'black--text' },
          { text: '', value: 'Actions', align: 'right' }
        ],
        loading: false,
        filter: false
      },
      body: {
        data: [],
        actions: [
          { title: 'Ver Equipos', icon: 'mdi-sitemap', color: 'blue', action: 'toEquipos', code: 'next.equipo' },
          { title: 'Editar', icon: 'mdi-pencil', color: 'amber darken-2', action: 'toUpdate', code: 'liga.entry' },
          { title: 'Agregar Integrante', icon: 'mdi-account-plus', color: 'success', action: 'newEncargado', code: 'create.integrante' },
          { title: 'Plantilla', icon: 'mdi-cards-variant', color: 'red', action: 'Plantilla1', code: 'new.plantilla' },
          { title: 'Generar Jornadas', icon: 'mdi-newspaper', color: 'grey', action: 'newJornadas', code: 'ligas.jornada' }
        ]
      },
      footer: {
        paging: true
      }
    },
    params: { groupBy: [], groupDesc: [], itemsPerPage: 10, multiSort: false, mustSort: false, page: 1, sortBy: [], sortDesc: [] },
    default: { groupBy: [], groupDesc: [], itemsPerPage: 10, multiSort: false, mustSort: false, page: 1, sortBy: [], sortDesc: [] },
    user: {},
    breadcrumb: [] // Inicializa el breadcrumb
  }),
  components: {
    DataTableMainServer,
    ViewDetails
  },
  mounted () {
    // Obtener el breadcrumb de la ruta
    this.breadcrumb = this.$route.meta.breadcrumb || []

    this.user = UserSession()
    this.refreshData({})
    this.ShowPermisos({ permisos: JSON.parse(localStorage.getItem('permisos')), tableMain: this.table })
  },
  methods: {
    ...mapActions(['getUrlServices', 'GETObjects', 'POSTPagination']),
    ...mapMutations(['SHOW_DIALOG_MAIN', 'SET_SERVICES', 'SHOW_DIALOG_REPORT']),
    SuccessTableAction (item) { this[item.action](item) },
    ExecuteUrl (url) {
      if (this.get_urls != null) {
        const router = this.get_urls[url]
        this.POSTPagination({ url: router, data: this.params })
      } else { this.getUrlServices() }
    },
    // *==========*==========*==========*    Methods Table Pagination    *==========*==========*==========* \\
    pagePagination (val) {
      this.table.header.loading = true // Muestra el estado de carga
      if (val) this.params = val // Actualiza params si se pasa un valor
      else this.params = this.default // Usa valores por defecto si no
      // Verifica que el espacio esté definido antes de usarlo
      if (!this.deporte) {
        console.error('El ID del espacio no está definido.')
        return // Sale si el ID del espacio no está disponible
      }
      // Asigna el espacioId usando el valor recibido como prop
      this.params.deporteId = this.deporte
      // Ejecuta la URL para obtener la paginación
      this.ExecuteUrl('ligas.list-pagination')
    },
    getSearchPagePagination (val) {
      this.table.header.loading = true
      this.params = val
      this.ExecuteUrl('ligas.list-pagination')
    },
    // *==========*==========*==========*==========*==========*==========*==========*==========*==========* \\
    filterData (item) {
      this.SHOW_DIALOG_MAIN({
        type: 'filter',
        with: '60%',
        title: 'FILTRAR',
        body: {
          objectMain: this.filterTableData,
          paramsDialog: {
            form: this.get_InventariosEquiposFilterForm,
            message: 'Registro Agregado Correctamente',
            returnObject: true,
            setmodel: true
          }
        }
      })
    },
    toEquipos (item) {
      const ligasId = { id: item.item.id, nombre: item.item.descripcion, torneo: (item.item.torneo ?? null) } // Asegúrate de que este sea el campo correcto para el ID del espacio
      this.$emit('viewEquipos', ligasId)
    },
    // ==========*==========*==========*==========*==========*==========*==========*==========* \\
    refreshData (item) {
      this.table.header.loading = true
      this.ExecuteUrl('ligas.list-pagination')
    },
    newData (item) {
      this.SHOW_DIALOG_MAIN({
        type: 'create',
        form: 'process',
        with: '50%',
        title: 'Nueva Liga',
        body: {
          objectMain: { tipo_actividad_id: 3, empresa_id: this.user.empresa_id, depor_id: this.deporte.id, user: this.user.usuario_id },
          paramsDialog: {
            url: this.get_urls['ligas.execute'],
            urloption: this.get_urls['ligas.options'],
            process: 3,
            actividad: 3,
            message: 'Registro Agregado Correctamente',
            setmodel: true,
            onSuccess: () => {
              this.refreshData() // Refrescar tabla después de la importación
            }
          }
        }
      })
    },
    toUpdate (item) {
      console.log('Datos antes:', item)
      console.log('Responsable:', item.item.descripcion.responsable)
      const data = {
        id: item.item.id,
        depor_id: item.item.descripcion.depor_id,
        nombreliga: item.item.nombre,
        maxteam: item.item?.descripcion?.maxteam,
        maxplayer: item.item?.descripcion?.maxplayer,
        user: this.user.usuario_id,
        liga_id: item.item.descripcion.liga_id,
        liga: item.item.descripcion.liga,
        tipo_actividad_id: item.item.descripcion.tipo_actividad_id,
        empresa_id: item.item.empresa_id,
        responsable: item.item.descripcion?.responsable?.id || '', // ID del responsable seleccionado
        responsableL: { // Objeto para inicializar el campo (opcional si el componente lo requiere)
          id: item.item.descripcion?.responsable?.id || '',
          NombreCompleto: item.item.descripcion.responsable?.NombreCompleto || '' // Nombre visible del responsable
        }
      }
      console.log('Datos a enviar para actualización:', data)
      const tituloDialogo = `Editar Liga De ${item.item.nombre || 'desconocido'}`
      this.SHOW_DIALOG_MAIN({
        type: 'update',
        form: 'process',
        with: '60%',
        title: tituloDialogo,
        body: {
          objectMain: data,
          paramsDialog: {
            urloption: this.get_urls['ligas.options'],
            url: this.get_urls['ligas.execute'],
            process: 1,
            message: 'Registro Actualizado Correctamente',
            updated: true,
            setmodel: true
          }
        }
      })
    },
    newEncargado (item) {
      console.log('empleado', this.user.empleado_id)
      const data = {
        empleado_id: this.user.empleado_id,
        item: item
      }
      this.SHOW_DIALOG_MAIN({
        type: 'create',
        with: 680,
        title: 'Nuevo Empleado',
        body: {
          objectMain: data,
          paramsDialog: {
            form: this.get_EmpleadoForm,
            url: this.get_urls['empresa.empleados.create'],
            message: 'Registro Agregado Correctamente',
            updated: true,
            returnObject: true,
            setmodel: true
          }
        }
      })
    },
    Plantilla1 ({ item }) {
      console.log('item:', item)
      this.SHOW_DIALOG_MAIN({
        type: 'charge',
        form: 'process',
        with: '50%',
        title: 'Documentacion',
        body: {
          objectMain: { num: 1, item, slug: 'esp' },
          paramsDialog: {
            url: this.get_urls['documentos.execute'],
            urloption: this.get_urls['documentos.options'],
            setmodel: true,
            data: item.item
          }
        }
      })
    },
    newJornadas (item) {
      console.log('item', item)
      const data = {
        ligaId: item.item.id,
        user: this.user.usuario_id
      }
      const tituloDialogo = `Confirmar Jornadas Para ${item.item.nombre || 'desconocido'}`
      this.SHOW_DIALOG_MAIN({
        type: 'create',
        with: '35%',
        title: tituloDialogo,
        body: {
          objectMain: data,
          paramsDialog: {
            form: this.get_JornadaForm,
            url: this.get_urls['ligas.jornada'],
            message: 'Registro Agregado Correctamente',
            setmodel: true
          }
        }
      })
    }
  },
  computed: {
    ...mapGetters(['get_urls', 'get_dialogMain', 'get_objectPagination', 'get_objects', 'get_EmpleadoForm', 'get_JornadaForm']),
    object () {
      return this.table.modelMain.length > 0 ? this.table.modelMain[0] : {}
    }
  },
  watch: {
    get_urls (val) { this.refreshData({}) },
    get_objectPagination (rows) {
      if (rows) {
        this.table.body.data = []
        this.table.header.loading = false
        this.table.body.data = rows.data
        this.table.body.totalData = rows.total
      }
    },
    get_sendDataView ({ name, model }) {
      if (name === 'create') {
        this.refreshData({})
      }
      this.SEND_DATA_VIEW({})
    }
  }
}
</script>

<style scoped>
/* Aquí puedes agregar estilos específicos para tu componente */
</style>
